import React from 'react';
import { Box, Typography } from '@mui/material';
import {
  PictureAsPdf,
  Description,
  TableChart
} from '@mui/icons-material';

/**
 * FormatBadge Component
 * 
 * @param {Object} props
 * @param {('pdf'|'csv'|'excel')} props.type - The type of export format
 * @param {Object} props.sx - Custom sx styles to apply to the container Box
 */
const FormatBadge = ({ type, sx = {} }) => {
  const getBadgeConfig = () => {
    switch (type) {
      case 'pdf':
        return {
          bgColor: '#fff0f0',
          borderColor: '#ffcdd2',
          textColor: '#c62828',
          iconColor: '#e53935',
          label: 'PDF Document',
          icon: PictureAsPdf
        };
      case 'csv':
        return {
          bgColor: '#e8f4fd',
          borderColor: '#bbdefb',
          textColor: '#1565c0',
          iconColor: '#1976d2',
          label: 'CSV Spreadsheet',
          icon: Description
        };
      case 'excel':
      default:
        return {
          bgColor: '#e8f5e9',
          borderColor: '#c8e6c9',
          textColor: '#1b5e20',
          iconColor: '#2e7d32',
          label: 'Excel Spreadsheet',
          icon: TableChart
        };
    }
  };

  const config = getBadgeConfig();
  const IconComponent = config.icon;

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.6,
        px: 1.2,
        py: 0.4,
        mb: 1.8,
        borderRadius: 5,
        bgcolor: config.bgColor,
        border: `1px solid ${config.borderColor}`,
        ...sx
      }}
    >
      <IconComponent sx={{ fontSize: 13, color: config.iconColor }} />
      <Typography
        sx={{
          fontSize: '0.68rem',
          fontWeight: 600,
          letterSpacing: 0.3,
          color: config.textColor,
        }}
      >
        {config.label}
      </Typography>
    </Box>
  );
};

export default FormatBadge;
